module.exports = __webpack_public_path__ + "img/product7.1df44eb8.png";